
























































import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import EditPage from "@/components/EditPage";
import { getKennungValueDisplay } from "@/DataHelper";

@Component
export default class WebWorkflowAntragPause extends EditPage {
  constructor() {
    super();
    this.query = "Web_Workflow_Antrag_Pause";
  }
  private anzeige: boolean = true;

  public mounted() {
    this.mountedBase();
    const antrag = getKennungValueDisplay(
      this.data,
      "ZE_ANTRAG_BOOL3",
      this.columns
    );
    if (antrag > 0) {
      this.anzeige = false;
    }
  }
}
